if (!customElements.get('feature-carousel')) {
  customElements.define(
    'feature-carousel',
    class FeatureCarousel extends HTMLElement {
      connectedCallback() {
        if (this.dataset.stack === 'true') return;
        this.waitForSwiper();
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      waitForSwiper() {
        if (window.Swiper) {
          this.init();
          return;
        }
        this.retries = (this.retries || 0) + 1;
        if (this.retries > 200) return;
        setTimeout(() => this.waitForSwiper(), 50);
      }

      init() {
        if (this.swiper) return;

        const container = this.querySelector('.swiper');
        if (!container) return;

        const count = this.querySelectorAll('.swiper-slide').length;
        const desktopPerView = parseFloat(this.dataset.desktopPerView) || 4.3;
        const mobilePerView = parseFloat(this.dataset.mobilePerView) || 1.3;
        const gapMobile = parseInt(this.dataset.gapMobile, 10) || 16;
        const gapDesktop = parseInt(this.dataset.gapDesktop, 10) || 24;

        this.swiper = new Swiper(container, {
          slidesPerView: count >= 2 ? mobilePerView : 1,
          spaceBetween: gapMobile,
          watchOverflow: true,
          breakpoints: {
            768: {
              slidesPerView: count > 4 ? desktopPerView : Math.min(count, 4),
              spaceBetween: gapDesktop,
            },
          },
        });
      }
    }
  );
}
